import { render, staticRenderFns } from "./Subscriptions-Holds.vue?vue&type=template&id=54290e30&"
import script from "./Subscriptions-Holds.vue?vue&type=script&lang=js&"
export * from "./Subscriptions-Holds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports